/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: dashboard-core (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define(['../../../api/DashboardAPI'], (DashboardAPI) => {

	class SetAsHomeActionHandler {

		isItemVisible(context) {
			const dashboard = context.glassContext.appController.getCurrentContentView().getDashboardApi();
			return dashboard.getMode() === DashboardAPI.MODES.VIEW;
		}

	}

	return SetAsHomeActionHandler;
});